<template>
    <button class="canvas-button" :style="{color, background: color}">
        <slot/>
    </button>
</template>

<script>
import Button from "@/Jetstream/Button";
export default {
    name: "CanvasButton",
    components: {Button},
    props: {
        color: {
            type: String,
            default: '#000',
        },
    },

}
</script>

<style lang="scss" scoped>
.canvas-button{
    display: inline-block;
    border-radius: .3rem;
    background: white;
    border: none;
    font-size: 1.1rem;
    font-weight: $font-weight-semibold;
    padding: .4rem .6rem;
    box-shadow: rgba(black, .2) 0 1px 4px;
    transition: background .3s, color .3s, box-shadow .3s;

    &:not(:hover){
        background: white !important;
    }

    &:hover{
        color: white !important;
        box-shadow: rgba(black, .2) 15px 15px 30px;
    }
}
</style>
